import { z } from 'zod'

export const myAccountGetCorporateInformationSchema = z.object({
  /** BIZ_ID */
  bizId: z.string(),
  /** CIBS_ID */
  cibsID: z.string(),
  /** 客戶名稱[英文] */
  englishName: z.string(),
  /** 客戶名稱[當地語系] */
  localName: z.string(),
  /** 郵遞區號 */
  postalCode: z.string(),
  /** 公司地址 */
  address: z.string(),
  /** 企業識別碼 */
  identifier: z.string(),
  /** 含識別碼網域 */
  url: z.string(),
  /** 場站 */
  station: z.string()
})

export interface MyAccountGetCorporateInformation
  extends z.infer<typeof myAccountGetCorporateInformationSchema> {}
